import { catchRestError, RestClient } from "clients/rest";
import { UseFormReturn } from "react-hook-form";
import { PageableResponse } from "../PageableResponse";

export type B000202FindRequest = { shohinbun: string } & Partial<{
  shodaibunCdFrom: string;
  shodaibunCdTo: string;
  shochubunCdFrom: string;
  shochubunCdTo: string;
  shoshobunCdFrom: string;
  shoshobunCdTo: string;
  name: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B000202FindResponse = {
  shodaibunCd: string;
  shohindaibunruiNm: string;
  shochubunCd: string;
  shohinchubunruiNm: string;
  shoshobunCd: string;
  shohinsyobunruiNm: string;
};

export const B000202Find = (props: B000202FindRequest) => {
  return RestClient.get<PageableResponse<B000202FindResponse[]>>(
    "b000202/find",
    {
      params: props,
    }
  );
};

export type B000202GetDaibunruiRequest = {
  shodaibun: string;
};

export type B000202GetDaibunruiResponse = {
  shodaibun: string;
  shohinbunruiNm: string;
  version: number;
};

export const B000202GetDaibunrui = (props: B000202GetDaibunruiRequest) => {
  return RestClient.get<B000202GetDaibunruiResponse>("b000202/get/daibunrui", {
    params: props,
  });
};

export type B000202GetChubunruiRequest = {
  shodaibun: string;
  shochubun: string;
};

export type B000202GetChubunruiResponse = {
  shodaibun: string;
  shochubun: string;
  shohinbunruiNm: string;
  version: number;
};

export const B000202GetChubunrui = (props: B000202GetChubunruiRequest) => {
  return RestClient.get<B000202GetChubunruiResponse>("b000202/get/chubunrui", {
    params: props,
  });
};

export type B000202GetShobunruiRequest = {
  shodaibun: string;
  shochubun: string;
  shoshobun: string;
};

export type B000202GetShobunruiResponse = {
  shodaibun: string;
  shochubun: string;
  shoshobun: string;
  shohinbunruiNm: string;
  version: number;
};

export const B000202GetShobunrui = (props: B000202GetShobunruiRequest) => {
  return RestClient.get<B000202GetShobunruiResponse>("b000202/get/shobunrui", {
    params: props,
  });
};

// B100110 商品大分類名取得メソッド
export const B000202ShodaibunruiNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shodaibun === "") {
    methods.setValue("shodaibunNm", "");
    return;
  }
  await B000202GetDaibunrui({ shodaibun: data.shodaibun })
    .then((response) => {
      methods.setValue("shodaibunNm", response.data.shohinbunruiNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shodaibunNm", "");
    });
};

// B100110 商品中分類名取得メソッド
export const B000202ShochubunruiNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shodaibun === "" || data.shochubun === "") {
    methods.setValue("shochubunNm", "");
    return;
  }
  await B000202GetChubunrui({
    shodaibun: data.shodaibun,
    shochubun: data.shochubun,
  })
    .then((response) => {
      methods.setValue("shochubunNm", response.data.shohinbunruiNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shochubunNm", "");
    });
};

// B100110 商品小分類名取得メソッド
export const B000202ShoshobunruiNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shodaibun === "" || data.shochubun === "" || data.shoshobun === "") {
    methods.setValue("shoshobunNm", "");
    return;
  }
  await B000202GetShobunrui({
    shodaibun: data.shodaibun,
    shochubun: data.shochubun,
    shoshobun: data.shoshobun,
  })
    .then((response) => {
      methods.setValue("shoshobunNm", response.data.shohinbunruiNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shoshobunNm", "");
    });
};

// B100120 商品大分類名取得メソッド
export const B100120ShohindaibunruiNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shodaibun === "") {
    methods.setValue("shohindaibunruiNm", "");
    methods.setValue("daiVersion", undefined);
    return;
  }
  await B000202GetDaibunrui({ shodaibun: data.shodaibun })
    .then((response) => {
      methods.setValue("shohindaibunruiNm", response.data.shohinbunruiNm ?? "");
      methods.setValue("daiVersion", response.data.version ?? undefined);
    })
    .catch((reason) => {
      if (methods.watch("modeKbn") !== "0") {
        catchRestError(reason, navigate, setMsg);
      }
      methods.setValue("shohindaibunruiNm", "");
      methods.setValue("daiVersion", undefined);
    });
};

// B100120 商品中分類名取得メソッド
export const B100120ShohinchubunruiNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shodaibun === "" || data.shochubun === "") {
    methods.setValue("shohinchubunruiNm", "");
    methods.setValue("chuVersion", undefined);
    return;
  }
  await B000202GetChubunrui({
    shodaibun: data.shodaibun,
    shochubun: data.shochubun,
  })
    .then((response) => {
      methods.setValue("shohinchubunruiNm", response.data.shohinbunruiNm ?? "");
      methods.setValue("chuVersion", response.data.version ?? undefined);
    })
    .catch((reason) => {
      if (methods.watch("modeKbn") !== "0") {
        catchRestError(reason, navigate, setMsg);
      }
      methods.setValue("shohinchubunruiNm", "");
      methods.setValue("chuVersion", undefined);
    });
};

// B100120 商品小分類名取得メソッド
export const B100120ShohinshobunruiNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shodaibun === "" || data.shochubun === "" || data.shoshobun === "") {
    methods.setValue("shohinshobunruiNm", "");
    methods.setValue("shoVersion", undefined);
    return;
  }
  await B000202GetShobunrui({
    shodaibun: data.shodaibun,
    shochubun: data.shochubun,
    shoshobun: data.shoshobun,
  })
    .then((response) => {
      methods.setValue("shohinshobunruiNm", response.data.shohinbunruiNm ?? "");
      methods.setValue("shoVersion", response.data.version ?? undefined);
    })
    .catch((reason) => {
      if (methods.watch("modeKbn") !== "0") {
        catchRestError(reason, navigate, setMsg);
      }
      methods.setValue("shohinshobunruiNm", "");
      methods.setValue("shoVersion", undefined);
    });
};

// B100120 商品大分類名取得メソッド
export const B100120ShohindaibunruiNmShohinbunruiNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shodaibun === "") {
    methods.setValue("shohindaibunruiNm", "");
    methods.setValue("daiVersion", undefined);
    methods.setValue("shohinbunruiNm", "");
    return;
  }
  await B000202GetDaibunrui({ shodaibun: data.shodaibun })
    .then((response) => {
      methods.setValue("shohindaibunruiNm", response.data.shohinbunruiNm ?? "");
      methods.setValue("daiVersion", response.data.version ?? undefined);
      methods.setValue("shohinbunruiNm", response.data.shohinbunruiNm ?? "");
    })
    .catch((reason) => {
      if (methods.watch("modeKbn") !== "0") {
        catchRestError(reason, navigate, setMsg);
      }
      methods.setValue("shohindaibunruiNm", "");
      methods.setValue("daiVersion", undefined);
      methods.setValue("shohinbunruiNm", "");
    });
};

// B100120 商品中分類名取得メソッド
export const B100120ShohinchubunruiNmShohinbunruiNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shodaibun === "" || data.shochubun === "") {
    methods.setValue("shohinchubunruiNm", "");
    methods.setValue("chuVersion", undefined);
    methods.setValue("shohinbunruiNm", "");
    return;
  }
  await B000202GetChubunrui({
    shodaibun: data.shodaibun,
    shochubun: data.shochubun,
  })
    .then((response) => {
      methods.setValue("shohinchubunruiNm", response.data.shohinbunruiNm ?? "");
      methods.setValue("chuVersion", response.data.version ?? undefined);
      methods.setValue("shohinbunruiNm", response.data.shohinbunruiNm ?? "");
    })
    .catch((reason) => {
      if (methods.watch("modeKbn") !== "0") {
        catchRestError(reason, navigate, setMsg);
      }
      methods.setValue("shohinchubunruiNm", "");
      methods.setValue("chuVersion", undefined);
      methods.setValue("shohinbunruiNm", "");
    });
};

// B100120 商品小分類名取得メソッド
export const B100120ShohinshobunruiNmShohinbunruiNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shodaibun === "" || data.shochubun === "" || data.shoshobun === "") {
    methods.setValue("shohinshobunruiNm", "");
    methods.setValue("shoVersion", undefined);
    methods.setValue("shohinbunruiNm", "");
    return;
  }
  await B000202GetShobunrui({
    shodaibun: data.shodaibun,
    shochubun: data.shochubun,
    shoshobun: data.shoshobun,
  })
    .then((response) => {
      methods.setValue("shohinshobunruiNm", response.data.shohinbunruiNm ?? "");
      methods.setValue("shoVersion", response.data.version ?? undefined);
      methods.setValue("shohinbunruiNm", response.data.shohinbunruiNm ?? "");
    })
    .catch((reason) => {
      if (methods.watch("modeKbn") !== "0") {
        catchRestError(reason, navigate, setMsg);
      }
      methods.setValue("shohinshobunruiNm", "");
      methods.setValue("shoVersion", undefined);
      methods.setValue("shohinbunruiNm", "");
    });
};

// B100140 商品大分類名From取得メソッド
export const B000202ShohindaibunruiNmFrom = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shodaibunFrom === "") {
    methods.setValue("shohindaibunruiNmFrom", "");
    return;
  }
  await B000202GetDaibunrui({ shodaibun: data.shodaibunFrom })
    .then((response) => {
      methods.setValue(
        "shohindaibunruiNmFrom",
        response.data.shohinbunruiNm ?? ""
      );
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shohindaibunruiNmFrom", "");
    });
};

// B100140 商品大分類名To取得メソッド
export const B000202ShohindaibunruiNmTo = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shodaibunTo === "") {
    methods.setValue("shohindaibunruiNmTo", "");
    return;
  }
  await B000202GetDaibunrui({ shodaibun: data.shodaibunTo })
    .then((response) => {
      methods.setValue(
        "shohindaibunruiNmTo",
        response.data.shohinbunruiNm ?? ""
      );
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shohindaibunruiNmTo", "");
    });
};

// B100140 商品中分類名From取得メソッド
export const B000202ShohinchubunruiNmFrom = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shodaibunFrom === "" || data.shochubunFrom === "") {
    methods.setValue("shohinchubunruiNmFrom", "");
    return;
  }
  await B000202GetChubunrui({
    shodaibun: data.shodaibunFrom,
    shochubun: data.shochubunFrom,
  })
    .then((response) => {
      methods.setValue(
        "shohinchubunruiNmFrom",
        response.data.shohinbunruiNm ?? ""
      );
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shohinchubunruiNmFrom", "");
    });
};

// B100140 商品中分類名To取得メソッド
export const B000202ShohinchubunruiNmTo = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shodaibunTo === "" || data.shochubunTo === "") {
    methods.setValue("shohinchubunruiNmTo", "");
    return;
  }
  await B000202GetChubunrui({
    shodaibun: data.shodaibunTo,
    shochubun: data.shochubunTo,
  })
    .then((response) => {
      methods.setValue(
        "shohinchubunruiNmTo",
        response.data.shohinbunruiNm ?? ""
      );
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shohinchubunruiNmTo", "");
    });
};

// B100140 商品小分類名From取得メソッド
export const B000202ShohinshobunruiNmFrom = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (
    data.shodaibunFrom === "" ||
    data.shochubunFrom === "" ||
    data.shoshobunFrom === ""
  ) {
    methods.setValue("shohinshobunruiNmFrom", "");
    return;
  }
  await B000202GetShobunrui({
    shodaibun: data.shodaibunFrom,
    shochubun: data.shochubunFrom,
    shoshobun: data.shoshobunFrom,
  })
    .then((response) => {
      methods.setValue(
        "shohinshobunruiNmFrom",
        response.data.shohinbunruiNm ?? ""
      );
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shohinshobunruiNmFrom", "");
    });
};

// B100140 商品小分類名To取得メソッド
export const B000202ShohinshobunruiNmTo = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (
    data.shodaibunTo === "" ||
    data.shochubunTo === "" ||
    data.shoshobunTo === ""
  ) {
    methods.setValue("shohinshobunruiNmTo", "");
    return;
  }
  await B000202GetShobunrui({
    shodaibun: data.shodaibunTo,
    shochubun: data.shochubunTo,
    shoshobun: data.shoshobunTo,
  })
    .then((response) => {
      methods.setValue(
        "shohinshobunruiNmTo",
        response.data.shohinbunruiNm ?? ""
      );
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shohinshobunruiNmTo", "");
    });
};
